import React, { useCallback, useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Bet } from "../../common/game/GameControl";
import { computeRaiseActionAmount } from "../../util/betUtils";

const BetButton = ({ BetTakeValueRef }) => {
  const gameState = useSelector((state) => state.gameState);
  const user = useSelector((state) => state.auth.user);

  // DC-FE-RAISE-MESSAGE-TDD-GREEN-001: Track input value for hint display
  const [inputValue, setInputValue] = useState(0);

  // US-005: Reset inputValue when turn changes to prevent stale hint on turn return
  useEffect(() => {
    setInputValue(0);
  }, [gameState.CurrentId]);

  // DC-FE-RAISE-MESSAGE-TDD-GREEN-001: Listen for input changes
  useEffect(() => {
    const inputElement = BetTakeValueRef?.current;
    if (!inputElement) return;

    // Initialize from current value
    const currentValue = parseInt(inputElement.value, 10);
    setInputValue(isNaN(currentValue) ? 0 : currentValue);

    // Listen for changes
    const handleInput = (e) => {
      const val = parseInt(e.target.value, 10);
      setInputValue(isNaN(val) ? 0 : val);
    };

    inputElement.addEventListener("input", handleInput);
    return () => inputElement.removeEventListener("input", handleInput);
  }, [BetTakeValueRef]);

  const currentIndex = useMemo(
    () => gameState.ActivePlayers.findIndex((x) => x.PlayerId === user.Id),
    [gameState.ActivePlayers, user.Id]
  );

  const currentPlayer = useMemo(() => {
    if (currentIndex === -1) return {};
    return gameState.ActivePlayers[currentIndex];
  }, [currentIndex, gameState.ActivePlayers]);

  const BetEventHandler = useCallback(
    (ev) => {
      try {
        // you should input betammount
        if (BetTakeValueRef.current.value === "") {
          // eslint-disable-next-line no-undef
          alert("bet amount is required");
          return;
        }

        let inputValue = parseInt(BetTakeValueRef.current.value);
        if (isNaN(inputValue)) {
          alert("Input correct number");
          return;
        }
        inputValue = parseFloat(inputValue);

        // Calculate bet-to-player (call amount) for mode determination
        const currentBet = gameState.CurrentBet;
        const currentRoundStatus = currentPlayer.CurrentRoundStatus || 0;
        const betToPlayer = currentBet - currentRoundStatus;

        let amountToSend;
        if (betToPlayer > 0) {
          // RAISE MODE: input is "raise BY X" (additional chips above the call)
          // Minimum raise is 0 (which equals a call)
          if (inputValue < 0) {
            alert("Raise amount cannot be negative");
            return;
          }
          amountToSend = computeRaiseActionAmount(currentBet, currentRoundStatus, inputValue);
        } else {
          // BET MODE: input is the bet amount directly (first bet of the round)
          if (inputValue <= 0) {
            alert("Bet amount must be greater than 0");
            return;
          }
          amountToSend = inputValue;
        }

        // DC-FE-REMOVE-LOCAL-DISPATCH-001: Call API only, state updated via SignalR "Bet" event
        Bet(user.Id, gameState.GameCode, currentIndex, amountToSend);

        // init BetTakeValue
        BetTakeValueRef.current.value = "";
      } catch (err) {}
    },
    [BetTakeValueRef, currentIndex, currentPlayer, gameState, user.Id]
  );

  if (gameState.CurrentId === user.Id && currentPlayer.PlayerCards.length > 0) {
    // DC-FE-UX-CLEANUP-ROUND3-001: Use bet-to-player (CurrentBet - CurrentRoundStatus) for label
    const betToPlayer = gameState.CurrentBet - (currentPlayer.CurrentRoundStatus || 0);

    // DC-FE-RAISE-MESSAGE-TDD-GREEN-001: Compute hint values for Raise mode
    const showHint = betToPlayer > 0 && inputValue > 0;
    const callAmount = betToPlayer;
    const hintRaiseBy = inputValue;
    const hintAmountThisAction = callAmount + hintRaiseBy;

    return (
        <>
            <button className="btn Bet mt-1 me-1 me-md-0" onClick={BetEventHandler}>
                &nbsp;{betToPlayer > 0 ? "Raise" : "Bet"}&nbsp;
            </button>
            {showHint && (
                <span className="raise-hint ms-2 text-light">
                    call {callAmount} + raise {hintRaiseBy} = {hintAmountThisAction}
                </span>
            )}
        </>
    );
  }
  return <></>;
};

export default BetButton;
